export default __webpack_public_path__ + "static/media/inc-42-logo.8e949206.svg";